var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { createForecastTableRow, refreshIframe, setDate, setTime, setWeather } from './common';
import { getForecast } from './forecast';
/**
 * Enables the "gorman field" page functionality.
 */
const enableGormanFieldFunctionality = () => __awaiter(void 0, void 0, void 0, function* () {
    if ($('#gorman-field').length === 0) {
        return;
    }
    /**
     * The current "forecast scroll" timeout identifier.
     */
    let forecastScrollTimeoutId;
    yield setWeather('current-weather-summary', 'current-weather-details', 'KRDR');
    yield _getForecast();
    setDate('date-data');
    setTime('time-data');
    // refresh the digital signage every hour
    setInterval(() => {
        refreshIframe('digital-signage');
    }, (1000 * 60 * 60));
    // refresh the weather data every two minutes
    setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        yield setWeather('current-weather-summary', 'current-weather-details', 'KRDR');
        yield _getForecast();
    }), (1000 * 60 * 2));
    // refresh the radar every minute
    setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        refreshIframe('radar');
    }), (1000 * 60));
    // refresh the current date/time every second
    setInterval(() => {
        setDate('date-data');
        setTime('time-data');
    }, (1000 * 1));
    /**
     * Sets the current weather forecast data on the page.
     */
    function _getForecast() {
        return __awaiter(this, void 0, void 0, function* () {
            const forecastContent = $('#forecast-content');
            const forecastNoData = $('#forecast-no-data');
            const periods = yield getForecast(47.8477, -97.3484);
            if (periods && (periods.length > 0)) {
                forecastContent.empty();
                for (let i = 0; i < periods.length; i++) {
                    forecastContent.append(createForecastTableRow(periods[i]));
                }
                forecastContent.show();
                forecastNoData.hide();
                // scroll the forecast
                _scrollForecast();
            }
            else {
                forecastContent.hide();
                forecastNoData.show();
            }
        });
    }
    /**
     * Scrolls the forecast content table within its container.
     */
    function _scrollForecast() {
        if (forecastScrollTimeoutId) {
            clearTimeout(forecastScrollTimeoutId);
        }
        // begin animation 20 seconds after loading (either after getting the data or scrolling to the top); the animation should take 100 seconds total before scrolling back to the top, where the last 10-15 seconds are spent at the bottom
        forecastScrollTimeoutId = window.setTimeout(function () {
            const $container = $('.middle > .right > .bottom .forecast .forecast-container');
            $container.animate({ scrollTop: $('#forecast-content')[0].scrollHeight }, (1000 * 100), 'linear', function () {
                $container.scrollTop(0);
            });
        }, (1000 * 20));
    }
});
export default enableGormanFieldFunctionality;
